import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import fetch from '../hooks/fetch';
import { fetchDictionaryReports } from '../actions';
import DictionaryReportsTable from '../components/DictionaryReportsTable';

const DictionaryReportsPanel = ({
  category,
  code,
  fetchData,
  readStatus,
  readErrors,
  reportType,
  reports,
}) => {
  fetch.useFetchDictionaryReports(fetchData, category, code, readStatus, reportType);
  return (
    <DictionaryReportsTable
      category={category}
      code={code}
      readStatus={readStatus}
      readErrors={readErrors}
      reports={reports}
      reportType={reportType}
    />
  );
};

const mapStateToProps = ({
  datasetReports: { dictionaryReports },
}, {
  category, code, reportType,
}) => {
  const item = findResult(dictionaryReports, category, code);
  const reports = item ? item[reportType] : {};

  return {
    readStatus: reports?.readStatus || states.NONE,
    readErrors: reports?.readErrors || [],
    reports: reports?.items || [],
  };
};

const mapDispatchToProps = {
  fetchData: fetchDictionaryReports,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryReportsPanel);
